/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from '../../../helpers/TokenDecoder';

export default {
    GetProductDetails,
    GetProductDetailsByProductID,
    SaveProductLifeCycle,
    UpdateProductLifeCycle,
    GetProductCategoties,
    GetProductTypes,
    GetProductLifeCycleDetails,
    GetProductLifeCycleDetailsByProductLifeCycleID,
    GetAllProductVarietyByProductID,
    GetPlantingMaterialDetailsForDropDown,
    GetProductLifeCycleDetailsByIDs
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductTypes() {
    const response = await CommonGet('/api/ProductType/GetAllProductTypes', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetProductDetailsByProductID(productID) {
    const response = await CommonGet('/api/Product/getProductDetailsByID', 'productID=' + productID);
    return response.data;
}

async function GetProductLifeCycleDetails(productCategoryID, productID) {
    const response = await CommonGet('/api/ProductLifeCycle/GetProductLifeCycleDetails', 'productCategoryID=' + parseInt(productCategoryID) + "&productID=" + parseInt(productID));
    return response.data;
}

async function GetProductLifeCycleDetailsByProductLifeCycleID(productLifeCycleID) {
    const response = await CommonGet('/api/ProductLifeCycle/GetProductLifeCycleDetailsByProductLifeCycleID', 'productLifeCycleID=' + parseInt(productLifeCycleID));
    return response.data;
}

async function SaveProductLifeCycle(values, pickingTable, selectedVarietyList, isSeasonal) {
    var formdata = {
        ProductCategoryID: parseInt(values.productCategoryID),
        ProductID: parseInt(values.cropID),
        PlantingMaterialTypeID: parseInt(values.plantingMaterialTypeID),
        DaysToHarvest: isSeasonal == false ? parseInt(values.daystoHarvesting) : parseInt(0),
        CultivationTypeID: parseInt(values.cultivationTypeID),
        HarvestingPeriod: isSeasonal == false ? parseFloat(values.harvestingPeriod) : parseFloat(0),
        HarvestingPeriodType: isSeasonal == false ? parseInt(values.harvestingPeriodType) : parseInt(0),
        Yield: parseFloat(values.yield),
        YieldUnit: parseInt(values.yieldType),
        HarvestingIntervals: parseInt(values.harvestingInterval),
        NoOfPickings: values.noOfPickings == "" ? parseInt(0) : parseInt(values.noOfPickings),
        NoOfPlants: parseInt(values.noOfPlants),
        SeedRatesPerAcre: parseFloat(values.seedRatesPerAcre),
        CreatedBy: parseInt(TokenDecoder.getUserIDFromToken()),
        harvestingStartDate: isSeasonal == true ? values.harvestingStartDate : "",
        harvestingEndDate: isSeasonal == true ? values.harvestingEndDate : "",
        PickingsSaveList: pickingTable,
        ProductVarietyIDList: selectedVarietyList,
        isSeasonal: isSeasonal,
        isActive: values.isActive
    }
    const response = await CommonPost('/api/ProductLifeCycle/SaveProductLifeCycle', null, formdata);
    return response;
}

async function UpdateProductLifeCycle(values, pickingTable, productLifeCycleID, isSeasonal) {
    var formdata = {
        ProductLifeCycleID: parseInt(productLifeCycleID),
        ProductVarietyID: parseInt(values.productVarietyID),
        PlantingMaterialTypeID: parseInt(values.plantingMaterialTypeID),
        CultivationTypeID: parseInt(values.cultivationTypeID),
        DaysToHarvest: parseInt(values.daystoHarvesting),
        HarvestingPeriod: parseFloat(values.harvestingPeriod),
        HarvestingPeriodType: parseInt(values.harvestingPeriodType),
        Yield: parseFloat(values.yield),
        YieldUnit: parseInt(values.yieldType),
        HarvestingIntervals: parseInt(values.harvestingInterval),
        NoOfPickings: values.noOfPickings == "" ? parseInt(pickingTable.length) : parseInt(pickingTable.length),
        NoOfPlants: parseInt(values.noOfPlants),
        SeedRatesPerAcre: parseFloat(values.seedRatesPerAcre),
        harvestingStartDate: isSeasonal == true ? values.harvestingStartDate : "",
        harvestingEndDate: isSeasonal == true ? values.harvestingEndDate : "",
        ModifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
        PickingsUpdateList: pickingTable,
        isActive: values.isActive
    }
    const response = await CommonPost('/api/ProductLifeCycle/UpdateProductLifeCycle', null, formdata);
    return response;
}

async function GetAllProductVarietyByProductID(productID) {
    const response = await CommonGet('/api/Product/GetAllProductVarietyByProductID', 'productID=' + productID);
    return response.data;
}

async function GetPlantingMaterialDetailsForDropDown() {
    const response = await CommonGet('/api/PlantingMaterial/PlantingMaterialDetailsForDropDown', null);
    return response.data;
}

async function GetProductLifeCycleDetailsByIDs(productCategoryID, productID) {
    const response = await CommonGet('/api/ProductLifeCycle/GetProductLifeCycleDetailsByIDs', 'productCategoryID=' + parseInt(productCategoryID) + "&productID=" + parseInt(productID));
    return response.data;
}